<template>
  <div class="parent">
    <ExternalFormCTAButton :margin="margin" />
  </div>
</template>
<script>
import ExternalFormCTAButton from './ExternalFormCTAButton.vue';

export default {
  props: ['margin'],
  components: { ExternalFormCTAButton },
};
</script>
<style scoped>
.parent {
  margin-top: auto;
  margin-bottom: 4rem;
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 768px) {
  .parent {
    margin-bottom: 6em;
    margin: unset;
    margin-bottom: unset;
    grid-area: cta;
    align-self: flex-end;
  }
}
</style>
